import React from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import { styled, Theme } from '@mui/material/styles'
import { StyledComponent } from '@emotion/styled'
import OutlinedInput, { OutlinedInputProps } from '@mui/material/OutlinedInput'
import tickIcon from '@/assets/tickicon.svg'

interface RoleInputPropsType {
  type?: string
  onClick?: () => void
  onChange?: () => void
  placeholder?: string
  selected: boolean
  value: string
}

const CustomInputField = styled(OutlinedInput)(
  ({ theme, selected }: { theme: Theme; selected: boolean }) => ({
    height: '80px',
    color: 'white',
    marginBottom: '15px',
    padding: '0 16px',
    width: '45vw',
    borderColor: '#365F91',
    border: ' 1.2px solid transparent',
    background: !selected
      ? `
    linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, #365f9133 100%) border-box
  `
      : '#fb5012',
    borderImageSlice: 1,
    borderRadius: '21px',

    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
    [theme.breakpoints.down('md')]: {
      width: '45vw',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
  }),
) as StyledComponent<OutlinedInputProps & { selected: boolean }>

const RoleInput = ({
  type,
  // value,
  onChange,
  placeholder,
  selected,
  ...props
}: RoleInputPropsType) => {
  return (
    <CustomInputField
      // value={value}
      className="!max-w-[556px]"
      type={type}
      onChange={onChange}
      placeholder={placeholder}
      selected={selected}
      fullWidth
      inputProps={{
        sx: {
          textAlign: 'left',
          paddingLeft: '16px',
        },
      }}
      endAdornment={
        selected && (
          <InputAdornment position="end">
            <img src={tickIcon} alt="tick" />
          </InputAdornment>
        )
      }
      {...props}
    />
  )
}

export default RoleInput
